import { type ReactNode } from 'react';
import {
  BirthdateField,
  EmailField,
  NameRow,
  type PersonalForm,
} from './approacher-edit-personal-parts';
import { LocationRow, PhoneRow } from './approacher-edit-contact-parts';

type Props = {
  f: PersonalForm;
  set: (k: keyof PersonalForm, v: string) => void;
};

export function PersonalSection({ f, set }: Props): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-sm">
      <NameRow f={f} set={set} />
      <EmailField f={f} set={set} />
      <PhoneRow f={f} set={set} />
      <LocationRow f={f} set={set} />
      <BirthdateField f={f} set={set} />
    </div>
  );
}
